import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import DropDownButton from '../../ui/DropDownButton';

import faBars from '@fortawesome/fontawesome-pro-light/faBars';

const ContextMenu = ({
  projectId,
  link,
  onDelete,
  onCopy,
  copying,
  userMode,
  superAdmin,
  suspendProject,
  router,
}) => {
  const adminMode = userMode === 'admin';

  const suspendItem = !superAdmin ? null : (
    <a
      onClick={() => {
        suspendProject(projectId);
      }}
      className="dropdown-item"
    >
      Suspend
    </a>
  );

  const copyItem = !copying ? (
    <a onClick={onCopy} className="dropdown-item">
      Copy
    </a>
  ) : (
    <a
      className="dropdown-item"
      style={{ opacity: '0.4', pointerEvents: 'none' }}
    >
      Copy
    </a>
  );

  const deleteItem =
    copying === projectId ? (
      <a
        className="dropdown-item"
        style={{ opacity: '0.4', pointerEvents: 'none' }}
      >
        Delete
      </a>
    ) : (
      <a onClick={onDelete} className="dropdown-item">
        Delete
      </a>
    );

  return (
    <DropDownButton
      title=""
      icon={faBars}
      mouseLeave
      hideToggle
      isHoverButton
      styleOverrides={{
        background: '#f5f5f5',
      }}
      style={{
        marginTop: 5,
        marginBottom: 5,
        marginRight: 5,
        float: 'right',
        zIndex: 3000,
      }}
    >
      <a onClick={() => router.push(link)} className="dropdown-item">
        View
      </a>
      {adminMode && deleteItem}
      {adminMode && copyItem}
      {suspendItem}
    </DropDownButton>
  );
};

ContextMenu.propTypes = {
  projectId: PropTypes.string,
  link: PropTypes.string,
  onDelete: PropTypes.func,
  onCopy: PropTypes.func,
  copying: PropTypes.bool,
  userMode: PropTypes.string,
};

// const ContextMenu = test => {
//   console.log(test);
//   return (
//     <div>yo</div>
//   );
// };

ContextMenu.propTypes = {
  projectId: PropTypes.string,
  link: PropTypes.string,
  onDelete: PropTypes.func,
  onCopy: PropTypes.func,
  copying: PropTypes.bool,
  userMode: PropTypes.string,
};

export default withRouter(ContextMenu);



// WEBPACK FOOTER //
// ./src/components/cards/contextMenus/projectContext.js